import { render } from "./icon-chevron-right.svg?vue&type=template&id=2424edb4"
const script = {}
script.render = render

export default script